import { Button } from "@fronterahealth/frontera-ui-components/ui/button";

import { useIsReviewPage } from "@components/ReportField/capabilities/flags";
import { ReviewRequestDialog } from "@components/ReportReview/ReviewRequestDialog";
import { useCanRequestReview } from "@components/ReportReview/hooks/useCanManageReview";
import { useReportReviewers } from "@components/ReportReview/hooks/useReportReviewers";

export const RequestReviewButton: React.FC = () => {
  const canRequestReview = useCanRequestReview();
  const { reviewers } = useReportReviewers();
  const isReviewPage = useIsReviewPage();

  if (!canRequestReview || reviewers.length || !isReviewPage) return null;

  return <ReviewRequestDialog trigger={<Button variant="outline">Request review</Button>} />;
};
